(function () {

  'use strict';

  function pxDownloadDesktopApplicationDialog($filter, $rootScope, ApplicationType, CpuArchitecture, FileType, OperatingSystem) {
    return {
      restrict: 'E',
      scope: {
        applicationVersionData: '=',
        onClose: '&'
      },
      templateUrl: 'app/components/softwareDistribution/downloadDesktopApplicationDialog/downloadDesktopApplicationDialog.template.html',
      link: function (scope, element, attributes) {

        scope.dialogTitle = buildDesktopApplicationTitle(
          scope.applicationVersionData.applicationType,
          scope.applicationVersionData.operatingSystem,
          scope.applicationVersionData.cpuArchitecture,
          scope.applicationVersionData.fileType
        );

        scope.onConfirmDialog = function () {
          scope.onClose();
        };

        scope.onCancelDialog = function () {
          scope.onClose();
        };

        function buildDesktopApplicationTitle(applicationType, operatingSystem, cpuArchitecture, fileType) {
          let title = '';
          switch (applicationType) {
            case ApplicationType.CLIENT:
              title += $rootScope.clientNameValue;
              break;
            case ApplicationType.CONFIGURATOR:
              title += $rootScope.configuratorNameValue;
              break;
            case ApplicationType.REDIRECTOR:
              title += $rootScope.redirectorNameValue;
              break;
          }
          title += ' - ';
          switch (operatingSystem) {
            case OperatingSystem.WIN:
              title += 'Windows';
              break;
            case OperatingSystem.MAC:
              title += 'Mac';
              break;
          }
          if (operatingSystem === OperatingSystem.WIN) {
            switch (cpuArchitecture) {
              case CpuArchitecture.X64:
                title += ' x64';
                break;
              case CpuArchitecture.ARM64:
                title += ' ARM64';
                break;
            }
            switch (fileType) {
              case FileType.EXE:
                title += ' (EXE)';
                break;
              case FileType.MSI:
                title += ' (MSI)';
                break;
            }
          }
          return $filter('stringular')($filter('translate')('DownloadColonItem'), title);
        }

      }
    };
  }

  pxDownloadDesktopApplicationDialog.$inject = ['$filter', '$rootScope', 'ApplicationType', 'CpuArchitecture', 'FileType', 'OperatingSystem'];

  angular
    .module('printix-admin')
    .directive('pxDownloadDesktopApplicationDialog', pxDownloadDesktopApplicationDialog);
})();
